<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    ダイス
    <b-input-group append="個以上" class="length">
      <b-form-select v-model="innerValue.args.cost" 
        :options="[
          { value:2, text:'2' },
        ]" 
        class="buff" />
    </b-input-group>
    <b-button variant="danger" size="sm"
      @click="$emit('remove')">
      <b-icon icon="x" />
    </b-button>
  </div>
</template>

<script>
import Hook from './Hook'
export default {
  extends: Hook
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
  width: 200px;
}
.length {
  display: inline-flex;
  width: 150px;
}
// .buff {
//   display: inline-block;
//   width: 50px;
// }
</style>